import {
  Required,
  IsString,
  DataValidator,
  transformKeys,
  IsBoolean,
  IsArray,
} from "@/utils/type-vaildator";
import api from "./api";

// 原始接口
export interface AgentUserGlobalTemplateAddResponse {
  message: string;
};

// 请求接口
export interface GlobalTemplateAddRequest {
  agentId: string;
  templateName: string;
  type: number;
  templateId: string;
  coverUrl: string;
  coverVideo?: string;
  scene?: string;
}

class ResultData {
  @IsBoolean("success_flag must be a boolean")
  successFlag: boolean;
}

export class GlobalTemplateAddData {
  @IsArray("results must be an array")
  results: ResultData[];
}

const transformAndValidateAgent = (
  response: AgentUserGlobalTemplateAddResponse
): GlobalTemplateAddData => {
  const transformedData = transformKeys(response);

  try {
    return DataValidator.validateOrThrow(transformedData, GlobalTemplateAddData);
  } catch (error) {
    console.error("Agent User Global Template Add data validation failed:", error.message);
    throw error;
  }
};

/** 添加企业用户模板 */
export const agentUserGlobalTemplateAdd = async (templateList: GlobalTemplateAddRequest[]): Promise<GlobalTemplateAddData> => {

  const params = templateList.map((item) => ({
    agent_id: item.agentId,
    template_name: item.templateName,
    type: item.type,
    template_id: item.templateId,
    cover_url: item.coverUrl,
    cover_video: item.coverVideo,
    scene: item.scene,
  }));

  const response = await api.post<AgentUserGlobalTemplateAddResponse>('/agent/user-global-template/add', {
    save_info: params,
  });
  const data = transformAndValidateAgent(response.data);
  return data;
};
